import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.SET_PROPERTY](state, { property, value }) {
    Vue.set(state.user, property, value);
  },

  [types.SET_TOKEN](state, token) {
    Vue.set(state, 'token', token);
  },

  [types.SET_USER](state, user) {
    Vue.set(state, 'user', user);
  },

  [types.SIGN_OUT](state) {
    Vue.delete(state, 'token');
    Vue.delete(state, 'user');
  },

  [types.SET_DEVICE](state, device) {
    Vue.set(state, 'device', device);
  },

  [types.SET_LICENCE](state, userLicence) {
    Vue.set(state, 'userLicence', userLicence);
  },

  [types.SET_PREMIUM_SCHOOL](state, premiumSchool) {
    Vue.set(state, 'premiumSchool', premiumSchool);
  },
};

export default mutations;
